import { defineComponent as _defineComponent } from 'vue'
import {PropType, reactive, ref} from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WorklogDetailsDialogTimeField',
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },
    errorMessages: {
      type: Array as PropType<Array<string>>,
      default: () => new Array<string>()
    },
    label: {
      type: String,
      default: () => ""
    },
    value: {
      type: String,
      default: () => ""
    }
  },
  setup(__props) {

const props = __props

  

  const initialState = {
    dialog: false
  };
  const state = reactive({...initialState});

  const dialog = ref();
  const timepicker = ref();

  function setHourView() {
    if (timepicker.value && timepicker.value.selecting) {
      timepicker.value.selecting = 1;
    }
  }

return { __sfc: true,props, initialState, state, dialog, timepicker, setHourView }
}

})